import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  Tbody,
  Tr,
  Th,
  Td,
  Thead,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  FormLabel,
  FormControl,
  useToast,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ViewCategory = () => {
  const toast = useToast();

  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null); // To store the selected category for editing
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");

  const fetchCategories = async () => {
    try {
      const schoolId = sessionStorage.getItem("school_id"); // Replace with actual school_id

      const response = await fetch(
        `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
      );
      const data = await response.json();
      if (data.success) {
        setCategories(data.data);
      } else {
        console.error("Failed to fetch categories:", data.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleViewClick = () => {
    fetchCategories();
    setIsModalOpen(true);
    setSelectedCategory(null); // Reset selected category to show the list
  };

  const handleEdit = async (id) => {
    try {
      const schoolId = sessionStorage.getItem("school_id");
      const response = await fetch(
        `${BASE_URL}/admin/library/category/view_category.php?cat_id=${id}`
      );
      const data = await response.json();
      if (data.success) {
        const category = data.data;
        setSelectedCategory(category);
        setCategoryName(category.name);
        setCategoryDescription(category.description);
        setIsModalOpen(true); // Open the modal when category details are loaded
      } else {
        console.error("Failed to fetch category details:", data.message);
      }
    } catch (error) {
      console.error("Error fetching category details:", error);
    }
  };

  const handleSave = async () => {
    try {
      const schoolId = sessionStorage.getItem("school_id");
      const userId = sessionStorage.getItem("user_id"); // Assuming user_id is stored in session

      const updatedCategory = {
        user_id: userId,
        school_id: schoolId,
        cat_id: selectedCategory.id,
        name: categoryName,
        description: categoryDescription,
      };

      const response = await fetch(
        `${BASE_URL}/admin/library/category/edit_category.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedCategory),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast({
          title: "Category Updated Successfully",
          description: "The category has been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        fetchCategories(); // Refresh the category list
        setIsModalOpen(false); // Close the modal after saving
      } else {
        console.error("Failed to update category:", data.message);
      }
    } catch (error) {
      console.error("Error updating category:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const schoolId = sessionStorage.getItem("school_id");
      const userId = sessionStorage.getItem("user_id");

      const categoryToDelete = {
        user_id: userId,
        school_id: schoolId,
        cat_id: id,
      };
      console.log("data del", categoryToDelete);

      const response = await fetch(
        `${BASE_URL}/admin/library/category/delete_category.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(categoryToDelete),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          toast({
            title: "Category Deleted Successfully",
            description: "The category has been deleted successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          fetchCategories(); // Refresh the category list after deletion
        } else {
          console.error("Failed to delete category:", data.message);
          toast({
            title: "Error",
            description: `Error: ${data.message}`,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } else {
        console.error("Server error:", response.statusText);
        toast({
          title: "Error Deleting Category",
          description:
            "An error occurred while deleting the category. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      toast({
        title: "Error Deleting Category",
        description: "An error occurred while deleting the category.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <Button colorScheme="green" onClick={handleViewClick}>
        View
      </Button>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          // bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            {selectedCategory ? "Edit Category" : "Category List"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {/* Category List */}
            {!selectedCategory ? (
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
              >
                <Thead>
                  <Tr>
                    <Th>Category Name</Th>
                    <Th>Description</Th>
                    <Th>Edit</Th>
                    <Th>Delete</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {categories.map((category) => (
                    <Tr key={category.id}>
                      <Td>{category.name}</Td>
                      <Td>{category.description}</Td>
                      <Td>
                        <Button
                          colorScheme="blue"
                          onClick={() => handleEdit(category.id)}
                        >
                          Edit
                        </Button>
                      </Td>
                      <Td>
                        <Button
                          colorScheme="red"
                          onClick={() => handleDelete(category.id)}
                        >
                          Delete
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              // Category Edit Form
              <div style={{ marginTop: "20px" }}>
                <FormControl mb={3}>
                  <FormLabel>Category Name</FormLabel>
                  <Input
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="Enter category name"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Category Description</FormLabel>
                  <Input
                    value={categoryDescription}
                    onChange={(e) => setCategoryDescription(e.target.value)}
                    placeholder="Enter category description"
                  />
                </FormControl>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            {selectedCategory ? (
              <Button colorScheme="blue" onClick={handleSave}>
                Save
              </Button>
            ) : (
              <Button colorScheme="red" onClick={closeModal}>
                Close
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ViewCategory;
